import { useModals } from '@any-ui-react/modals';

import { VariablePluginOption } from '@anyx/feature-crm/shared';

import { useUnitMessageAssetUpload } from '../../../hooks';
import { LineMessageDialog } from '../LineMessageDialog';
import { LineMessageDialogFormFields } from '../types';

const MODAL_ID = 'line-message-modal';

interface OpenLineMessageDialogProps {
  messageId?: string;
  onSubmit: (props: {
    updatedDraftContent: string;
    lineMessageDialog: LineMessageDialogFormFields;
  }) => void;
  initialValues?: LineMessageDialogFormFields;
}

export const useLineMessageDialog = ({
  variablePluginOptions,
}: {
  variablePluginOptions?: VariablePluginOption[];
} = {}) => {
  const { openModal, closeModal } = useModals();

  const { uploadUnitMessageAsset } = useUnitMessageAssetUpload();

  const openLineMessageDialog = ({
    messageId,
    onSubmit,
    initialValues,
  }: OpenLineMessageDialogProps) => {
    openModal({
      size: 'auto',
      modalId: MODAL_ID,
      children: (
        <LineMessageDialog
          variablePluginOptions={variablePluginOptions}
          initialValues={initialValues}
          messageId={messageId}
          onImageUpload={uploadUnitMessageAsset}
          onCancel={() => closeModal(MODAL_ID)}
          onSubmit={({ updatedDraftContent, lineMessageDialog }) => {
            onSubmit({ updatedDraftContent, lineMessageDialog });
            closeModal(MODAL_ID);
          }}
        />
      ),
    });
  };

  return {
    openLineMessageDialog,
  };
};
